import {
  DEFAULT_DATETIME_DAY_FORMAT,
  formatDateTimeFromMillis
} from "../../../../../utils"

interface Props {
  timestamp?: number
  quoteId?: string
}

const QuoteDate = ({ timestamp, quoteId }: Props) => {
  return (
    <time
      {...(timestamp ? { dateTime: new Date(timestamp)?.toISOString() } : {})}
      className="font-bold text-lg pb-4"
    >
      {timestamp
        ? formatDateTimeFromMillis(
            timestamp * 1000,
            DEFAULT_DATETIME_DAY_FORMAT
          )
        : "Unknown date"}
      {quoteId && (
        <span className="ml-2 text-neutral-500">- Quote ID: {quoteId}</span>
      )}
    </time>
  )
}

export default QuoteDate
